import axios from 'axios';
import backendAxios from '../utils/backendAxios';

import {
  PROFILE_ERRORS, GET_PROFILE, UPDATE_PROFILE_SERVICE, DELETE_IMG_PROFILE,
  DELETE_PROFILE_SERVICE, UPDATE_PROFILE_SERVICE_STATUS, GET_FAVORITES,
  UPDATE_PROFILE_PAGE_STATUS
} from './types';
// Get favorite services (2026)
export const getFavorites = () => async dispatch => {
  try {
    const res = await backendAxios.get('/api/profile/favorites');
    dispatch({
      type: GET_FAVORITES,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: "Error al obtener favoritos", status: 500 }
    });
  }
};
import { URL } from './url';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

// Get current profile (2025)
export const getCurrentProfile = () => async dispatch => {
  try {
    const res = await backendAxios.get(`/api/profile/me`);
    dispatch({
      type: GET_PROFILE,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

//Get profile by id user (2026)
export const getProfileId = async id => {
  if (!id || id === 'undefined') return null;
  try {
    const res = await backendAxios.get(`/api/profile/id/${id}`);
    return res.data
  } catch (err) {
    console.error("Error al obtener el perfil", err);
  }
};

// Reputación pública de una persona (datos reales): { serviciosRealizados, evaluaciones, identidadVerificada }.
// Devuelve null si falla, para que la pantalla muestre "—" en vez de números inventados.
export const getReputacion = async userId => {
  if (!userId || userId === 'undefined') return null;
  try {
    const res = await backendAxios.get(`/api/profile/reputacion/${userId}`);
    return res.data;
  } catch (err) {
    console.error("Error al obtener la reputación", err);
    return null;
  }
};

// Proveedores para «Perfiles de proveedores» del perfil público: con `para` (el id de ese perfil), primero los de sus categorías
export const getTopProviders = async (para) => {
  try {
    const res = await backendAxios.get(`/api/profile/topProviders${para ? `?para=${encodeURIComponent(para)}` : ''}`);
    return res.data;
  } catch (err) {
    console.error("Error al obtener proveedores top", err);
    return [];
  }
};

// Get latest services (2026)
export const getLatestServices = async () => {
  try {
    const res = await backendAxios.get(`/api/profile/latestServices`);
    return res.data;
  } catch (err) {
    console.error("Error al obtener últimos servicios", err);
    return [];
  }
};

// Servicios con dirección para el mapa del home (2026)
export const getMapServices = async (limit = 40) => {
  try {
    const res = await backendAxios.get(`/api/profile/mapServices?limit=${limit}`);
    return res.data;
  } catch (err) {
    console.error("Error al obtener servicios para el mapa", err);
    return [];
  }
};

// Get Public Service detail (2026)
export const getPublicServiceDetail = async (userId, serviceId) => {
  if (!userId || userId === 'undefined' || !serviceId || serviceId === 'undefined') {
    return null;
  }
  try {
    const res = await backendAxios.get(`/api/profile/public/service/${userId}/${serviceId}`);
    return res.data;
  } catch (err) {
    // 403: el servicio existe pero todavía no se puede ver (p. ej. falta que acepte quien lo va a impartir). Se devuelve el motivo,
    // sin `service`, para que la pantalla lo explique en vez de mandar a la persona al inicio de sesión.
    if (err.response?.status === 403) return { noDisponible: true, msg: err.response.data?.msg || 'Este servicio no está disponible.' };
    // 400 (id inválido) o 404 (no existe el servicio o su perfil): la ficha dice «No encontramos esta página»
    if (err.response?.status === 400 || err.response?.status === 404) return { noEncontrado: true };
    console.error("Error al obtener detalle público de servicio", err);
    return null;
  }
};

// Get Public Page detail (2026)
export const getPublicPageDetail = async (pageId) => {
  if (!pageId || pageId === 'undefined') {
    return null;
  }
  try {
    const res = await backendAxios.get(`/api/profile/public/page/${pageId}`);
    return res.data;
  } catch (err) {
    console.error("Error al obtener detalle público de página", err);
    return null;
  }
};// Get latest pages (2026)
export const getLatestPages = async () => {
  try {
    const res = await backendAxios.get(`/api/profile/latestPages`);
    return res.data;
  } catch (err) {
    console.error("Error al obtener últimas páginas", err);
    return [];
  }
};

// Búsqueda unificada: personas, servicios y páginas (2026)
export const searchAll = async ({ q = '', categoria = '', subcategoria = '', tag = '' } = {}) => {
  try {
    const params = new URLSearchParams();
    if (q) params.append('q', q);
    if (categoria) params.append('categoria', categoria);
    if (subcategoria) params.append('subcategoria', subcategoria);
    if (tag) params.append('tag', tag);
    const res = await backendAxios.get(`/api/profile/search?${params.toString()}`);
    return res.data;
  } catch (err) {
    console.error('Error en la búsqueda', err);
    return { personas: [], servicios: [], paginasIndependientes: [], paginasGrupos: [], total: 0 };
  }
};

// Upload img
export const uploadFile = (formData) => async dispatch => {
  try {
    // backendAxios para enviar el x-auth-token (el endpoint /upload ahora exige sesión).
    // Content-Type multipart explícito para que Axios 1.x NO convierta el FormData a JSON.
    await backendAxios.post(`/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}

// Upload multiple files
export const uploadMultipleFiles = formData => async dispatch => {
  try {
    await backendAxios.post(`/multiple/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  } catch (err) {
    // err.response puede ser undefined en errores de red; sin optional chaining lanzaría TypeError
    dispatch({
      type: PROFILE_ERRORS,
      payload: err.response?.data?.msg || err.message
    });
  }
}

/****************DIRECCIONES***************/

// Add profile address (2025)
export const addProfileAddress = formData => async (dispatch, getState) => {
  try {
    const res = await backendAxios.post(`/api/profile/address`, formData);

    // La respuesta es el perfil SIN servicios ni páginas (solo /me los adjunta): se mezcla con el
    // perfil actual para no perderlos; el formulario de páginas los sigue usando tras agregar una dirección.
    dispatch({
      type: GET_PROFILE,
      payload: { ...getState().profile.profile, ...res.data }
    });
    return true
  } catch (err) {
    console.error(err, "Error al agregar dirección de perfil (addProfileAddress)");
    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: err.response.statusText, status: err.response.status }
    })
  }
};

// Update profile address (2025)
export const updateProfileAddress = (formData, id) => async dispatch => {
  try {
    const res = await backendAxios.patch(`/api/profile/address/${id}`, formData);

    dispatch({
      type: GET_PROFILE,
      payload: res.data
    });
    return true;
  } catch (err) {
    console.error(err, "Error al actualizar dirección de perfil");
    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
}

// delete profile address (2025)
export const deleteProfileAddress = id => async dispatch => {
  try {
    const res = await backendAxios.delete(`api/profile/address/${id}`);
    // Como al agregar o editar: el servidor devuelve el perfil ya sin la dirección. Si no la encontró devuelve null y se deja el que
    // hay (el reductor lee el perfil en cada acción: uno vacío rompería la web)
    if (res.data) {
      dispatch({
        type: GET_PROFILE,
        payload: res.data
      });
    }
  } catch (err) {
    console.error(err, "Error al eliminar dirección de perfil");
    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
}

/******************SERVICIOS*****************/

// Add profile servicios (2025??)
export const addProfileService = (formData, imgData) => async dispatch => {
  try {

    // formData is now the JSON object for the DB save
    const res = await backendAxios.post(`api/profile/service`, formData);

    dispatch({
      type: GET_PROFILE,
      payload: res.data.profile
    });

    if (imgData && imgData.has('files')) {
      const serviceId = res.data.servicio; // Backend returns the ID directly as 'servicio'

      // Append folder path
      imgData.append('carpeta', `servicios/${serviceId}`);

      console.log('Uploading images to:', `servicios/${serviceId}`);
      await dispatch(uploadMultipleFiles(imgData));
    }

    return res.data.success;
  } catch (err) {
    const msg = err.response ? err.response.statusText : "Error de conexión o servidor";
    const status = err.response ? err.response.status : 500;

    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg, status }
    });
  }
};

// Update profile servicios (2025??)
export const updateProfileService = (formData, id, imgData = '') => async dispatch => {
  try {
    const res = await backendAxios.patch(`api/profile/service/${id}`, formData);
    dispatch({
      type: UPDATE_PROFILE_SERVICE,
      payload: res.data.servicio
    });

    // Igual que en addProfileService: solo subir si hay archivos reales
    if (imgData && imgData.has && imgData.has('files')) {
      imgData.append('carpeta', `servicios/${id}`);
      await dispatch(uploadMultipleFiles(imgData));
    }

    return res.data.success;
  } catch (err) {
    console.error(err, "Error: updateProfileService");
    const msg = err.response ? err.response.statusText : "Error desconocido al actualizar servicio";
    const status = err.response ? err.response.status : 500;

    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg, status }
    });
  }
}

// Update profile servicios status (2025)
export const updateProfileServiceStatus = (formData, id) => async dispatch => {
  try {
    const res = await backendAxios.patch(`api/profile/service/status/${id}`, formData);

    dispatch({
      type: UPDATE_PROFILE_SERVICE_STATUS,
      payload: res.data.servicios
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERRORS,
      payload: err
    });
  }
}

// delete profile servicios (2025??)
export const deleteProfileService = id => async dispatch => {
  try {
    const res = await backendAxios.delete(`api/profile/service/${id}`);
    dispatch({
      type: DELETE_PROFILE_SERVICE,
      payload: res.data.servicios
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }

}

// Add profile page (2026)
export const addProfilePage = (formData, imgData) => async dispatch => {
  try {
    const res = await backendAxios.post(`api/profile/pagina`, formData);

    dispatch({
      type: GET_PROFILE,
      payload: res.data.profile
    });

    if (imgData && imgData.has('file')) {
      const pageId = res.data.pagina;

      // Append folder path
      imgData.append('carpeta', `paginas/${pageId}`);

      console.log('Uploading banner to:', `paginas/${pageId}`);
      await dispatch(uploadFile(imgData));
    }

    // `invitaciones`: cuántas personas recibieron la invitación para impartir un servicio de la página
    return { ok: res.data.success === true, invitaciones: res.data.invitacionesEnviadas || 0 };
  } catch (err) {
    const msg = err.response ? err.response.statusText : "Error de conexión o servidor";
    const status = err.response ? err.response.status : 500;

    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg, status }
    });
    // El motivo que manda el servidor (p. ej. servicios de otra categoría) llega al formulario para mostrarlo
    return { ok: false, error: err.response?.data?.msg || null };
  }
};

// Update profile page (2026)
export const updateProfilePage = (formData, id, imgData) => async dispatch => {
  try {
    const res = await backendAxios.patch(`api/profile/pagina/${id}`, formData);

    dispatch({
      type: GET_PROFILE,
      payload: res.data.profile
    });

    if (imgData && imgData.has('file')) {
      // Append folder path
      imgData.append('carpeta', `paginas/${id}`);
      await dispatch(uploadFile(imgData));
    }

    return { ok: res.data.success === true, invitaciones: res.data.invitacionesEnviadas || 0 };
  } catch (err) {
    const msg = err.response ? err.response.statusText : "Error de conexión";
    const status = err.response ? err.response.status : 500;

    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg, status }
    });
    return { ok: false, error: err.response?.data?.msg || null };
  }
};

// Volver a avisar a quien imparte un servicio de la página y aún no responde (o invitar de nuevo a quien había rechazado).
// No toca el perfil guardado en Redux: el formulario de la página sigue con lo que la persona tenga a medio editar.
export const inviteFacilitator = (pageId, facilitatorId, serviceId) => async () => {
  try {
    const res = await backendAxios.post(`api/profile/pagina/${pageId}/invite`, { facilitatorId, serviceId });
    return { success: res.data.success === true, msg: res.data.msg, estado: res.data.estado };
  } catch (err) {
    console.error(err, "Error al invitar facilitador");
    return { success: false, msg: err.response?.data?.msg || "No se pudo enviar la invitación. Inténtalo de nuevo." };
  }
};

// Update profile page status (2026)
export const updateProfilePageStatus = (formData, id) => async dispatch => {
  try {
    const res = await backendAxios.patch(`api/profile/pagina/status/${id}`, formData);

    // Activar o pausar una página cambia qué servicios esperan a quien los imparte: el servidor manda también los servicios
    dispatch({
      type: UPDATE_PROFILE_PAGE_STATUS,
      payload: { paginas: res.data.paginas, servicios: res.data.servicios }
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERRORS,
      payload: err
    });
  }
}


// Delete profile page (2026)
export const deleteProfilePage = id => async dispatch => {
  try {
    const res = await backendAxios.delete(`api/profile/pagina/${id}`);

    dispatch({
      type: GET_PROFILE, // Re-using GET_PROFILE since we return the full profile
      payload: res.data.profile
    });
  } catch (err) {
    const msg = err.response ? err.response.statusText : "Error de conexión";
    const status = err.response ? err.response.status : 500;

    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg, status }
    });
  }
};

/******************FACTURACION*****************/

// Add profile servicios
export const addProfileFacturacion = (formData, history) => async dispatch => {
  try {
    const res = await axios.post(`${URL}/api/profile/facturacion`, formData, config);
    dispatch({
      type: GET_PROFILE,
      payload: res.data.profile
    });
    history('../datos-facturacion');
  } catch (err) {
    const errors = err.response.data.errors;

    // if(errors){
    //   errors.forEach(error => dispatch(setAlert(error.msg)));
    // }

    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: err.response.statusText, status: err.response.status }
    })
  }
};

// Update profile servicios
export const updateProfileFacturacion = (formData, id, history) => async dispatch => {
  try {
    const res = await axios.patch(`${URL}/api/profile/facturacion/${id}`, formData, config);

    dispatch({
      type: GET_PROFILE,
      payload: res.data
    });
    history('../datos-facturacion');
  } catch (err) {
    const errors = err.response.data.errors;

    // if(errors){
    //   errors.forEach(error => dispatch(setAlert(error.msg)));
    // }

    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
}

// Update profile servicios status
export const updateProfileFacturacionStatus = (formData, id) => async dispatch => {
  try {
    const res = await axios.patch(`${URL}/api/profile/facturacion/status/${id}`, formData, config);

    dispatch({
      type: GET_PROFILE,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERRORS,
      payload: err
    });
  }
}

// delete profile facturacion
export const deleteProfileFacturacion = id => async dispatch => {
  try {
    const res = await axios.delete(`${URL}/api/profile/facturacion/${id}`);

    dispatch({
      type: UPDATE_PROFILE,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
}

/******************REDES*****************/

// Update profile redes (2025)
export const updateProfileRedes = formData => async dispatch => {
  try {
    const res = await backendAxios.post(`/api/profile/redes`, formData);
    dispatch({
      type: GET_PROFILE,
      payload: res.data
    });
  } catch (err) {
    console.error(err, "Error al actualizar redes de perfil (updateProfileRedes)");
    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
}

// Delete service image
export const deleteServiceImage = (serviceId, imgName) => async dispatch => {
  try {
    const res = await backendAxios.delete(`/api/profile/service/${serviceId}/image/${imgName}`);

    // Dispatch updated profile
    dispatch({
      type: GET_PROFILE,
      payload: res.data
    });

    return true;
  } catch (err) {
    console.error(err, "Error deleting service image");
    const msg = err.response ? err.response.statusText : "Error al eliminar imagen";
    const status = err.response ? err.response.status : 500;

    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg, status }
    });
    return false;
  }
}

/******************PERFIL*********************/

// Update profile perfil (2025)
export const updateProfile = formData => async dispatch => {
  try {
    const res = await backendAxios.post(`/api/profile/perfil`, formData);
    dispatch({
      type: GET_PROFILE,
      payload: res.data
    });
  } catch (err) {
    console.error(err, "Error al actualizar perfil (upadateProfile");
    dispatch({
      type: PROFILE_ERRORS,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
}